import { ContactId } from 'modules/contacts/types/contact-interface'

export const getEditContactPageUrl = (contactId: ContactId) => `/contacts/${contactId}`
